module.exports = __webpack_public_path__ + "img/cta-google-play.fae7f716.svg";